import Api from '../../helpers/Api';

// Field type categories
export const FIELD_CATEGORIES = {
	BASIC: 'basic',
	SELECTION: 'selection',
	SPECIAL: 'special',
	LAYOUT: 'layout',
};

// Map API field types to categories and additional UI metadata
export const fieldTypeMetadata = {
	// Basic Fields
	text: { category: FIELD_CATEGORIES.BASIC, icon: 'FiType' },
	textarea: { category: FIELD_CATEGORIES.BASIC, icon: 'FiAlignLeft' },
	number: { category: FIELD_CATEGORIES.BASIC, icon: 'FiHash' },
	email: { category: FIELD_CATEGORIES.BASIC, icon: 'FiMail' },
	phone: { category: FIELD_CATEGORIES.BASIC, icon: 'FiPhone' },
	url: { category: FIELD_CATEGORIES.BASIC, icon: 'FiLink' },

	// Selection Fields
	select: { category: FIELD_CATEGORIES.SELECTION, icon: 'FiChevronDown' },
	multiselect: { category: FIELD_CATEGORIES.SELECTION, icon: 'FiList' },
	radio: { category: FIELD_CATEGORIES.SELECTION, icon: 'FiCircle' },
	checkbox: { category: FIELD_CATEGORIES.SELECTION, icon: 'FiSquare' },

	// Special Fields
	file: { category: FIELD_CATEGORIES.SPECIAL, icon: 'FiFile' },
	address: {
		category: FIELD_CATEGORIES.SPECIAL,
		icon: 'FiMapPin',
		requiresGooglePlaces: true,
	},

	// Layout Fields
	heading: { category: FIELD_CATEGORIES.LAYOUT, icon: 'FiType' },
	paragraph: { category: FIELD_CATEGORIES.LAYOUT, icon: 'FiAlignLeft' },
	divider: { category: FIELD_CATEGORIES.LAYOUT, icon: 'FiMinus' },
};

// Cache for field types from API
let cachedFieldTypes = null;

// Function to fetch and transform field types from API
export const getFieldTypes = async (token) => {
	if (cachedFieldTypes) return cachedFieldTypes;

	try {
		const header = { Authorization: `Bearer ${token}` };
		const response = await Api.request(
			'api/admin/forms/field-types',
			{},
			'get',
			header
		);
		const { fieldTypes } = response;

		// Transform API field types to include UI metadata
		const transformedFieldTypes = fieldTypes.map((fieldType) => ({
			...fieldType,
			...(fieldTypeMetadata[fieldType.id] || {
				category: FIELD_CATEGORIES.BASIC,
			}),
			value: fieldType.id, // For backwards compatibility with existing code
		}));

		// Group by category
		const groupedFieldTypes = Object.values(FIELD_CATEGORIES).reduce(
			(acc, category) => {
				acc[category] = transformedFieldTypes.filter(
					(ft) => ft.category === category
				);
				return acc;
			},
			{}
		);

		cachedFieldTypes = {
			all: transformedFieldTypes,
			grouped: groupedFieldTypes,
		};

		return cachedFieldTypes;
	} catch (error) {
		console.error('Error fetching field types:', error);
		return {
			all: [],
			grouped: Object.values(FIELD_CATEGORIES).reduce(
				(acc, cat) => ({ ...acc, [cat]: [] }),
				{}
			),
		};
	}
};
